import React, {PureComponent} from 'react';
import {bool, func, node, string} from 'prop-types';
import styles from './Tag.scss';
import {default as Icon} from '@sinclair-digital/sbg-storyline-components/src/components/Icon';
import {close} from 'react-icons-kit/fa/close';
import {lock} from 'react-icons-kit/fa/lock';
import classNames from 'classnames';

export const tagShape = {
    tagBody: node,
    header: string.isRequired,
    locked: bool,
};

class Tag extends PureComponent {
    static propTypes = {
        className: string,
        onRemoveTag: func,
        ...tagShape,
    };

    static defaultProps = {
        onRemoveTag: undefined,
    };

    render() {
        const {className, tagBody, header, locked, onRemoveTag} = this.props;
        return (
            <div className={classNames(className, styles.Tag)}>
                <div className={styles.tagName}>{header}</div>
                <div className={styles.tagBody}>{tagBody}</div>
                {locked ? (
                    <span className={styles.lockedTag}>
                        <Icon icon={lock} />
                    </span>
                ) : (
                    <a onClick={onRemoveTag} className={styles.removeTag}>
                        <Icon icon={close} />
                    </a>
                )}
            </div>
        );
    }
}

export default Tag;
